export type GetSettingsAuthorizationApiResponse =
  /** status 200 Standard response */
  | ({
      id?: string | null;
      name?: string | null;
      code?: string | null;
      vehicleMakes?: (string | null)[];
      vehicleModels?: (string | null)[];
      vehicleTypes?: (string | null)[];
      nationalSalesCompanyId?: string | null;
    } | null)[]
  | /** status 204 Standard response */ undefined;
export type GetSettingsAuthorizationApiArg = unknown;
